import { Card, CardBody, CardFooter, CardHeader, Image  } from '@nextui-org/react'
import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useInfiniteQuery, useQueryClient, useMutation,useQuery  } from '@tanstack/react-query';
import { getAllArticles } from '../../services/querys '
import Pagination from '../../components/Pagination/Pagination'
import moment from 'moment';
import { Spin } from 'antd';


function AllArticle() {

    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const { data, error, isLoading } = useQuery({
        queryKey: ['articles', currentPage],
        queryFn: async () => {
            const response = await getAllArticles({ page: currentPage });
            setTotalPages(response.pages); 
            return response;
        },
    }); 


    const navigateToArticle = (id) => {
        if (!id) {
            message.error('Articles ID not found');
        }
        navigate(`/community/articles/${id}`)
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    return (
        <>
        <div className='mt-8 sm:mt-[75px] font-poppins'>
            <h2 className='text-2xl font-bold text-gray-200'>All Articles</h2>

            <Spin spinning={isLoading} />

            <div className='mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 '>
            {data?.articles?.map((data, index) => 
                  <Card 
                  key={index}
                  isPressable
                  onPress={() => navigateToArticle(data?.articleId)}
                  isFooterBlurred 
                  className="w-full h-[300px] ">
                    <CardHeader className="absolute z-10 flex-col bg-black/40 items-start border-b-1 border-default-700">
                      <p className="text-tiny text-white/60 uppercase font-bold"> {moment(data?.updatedAt).fromNow()} | by editor</p>
                      <h4 className="text-white/90 font-medium text-xl line-clamp-2 text-start"> #{data?.articleName}</h4>
                    </CardHeader>
                    <Image
                      isZoomed
                      removeWrapper
                      alt="Relaxing app background"
                      className="z-0 w-full h-full object-cover"
                      src={data?.image[0]?.url || '/img/test.png'}
                    />
                    <CardFooter className="absolute bg-black/40 bottom-0 z-10 border-t-1 border-default-600 dark:border-default-100">
                      <div className="flex flex-grow gap-2 items-center">
  
                        <div className="flex flex-col">
                          {/* <p className="text-md text-white/60 line-clamp-3 text-start">{data?.description}</p> */}
                          <p className='text-md text-white/60 line-clamp-3 font-poppins text-start'>
                        {data?.description ? data?.description.replace(/<[^>]+>/g, '') : ''}
                        </p>
                        </div>
                      </div>
                    </CardFooter>
                  </Card>
            )}
            </div>


        </div>
       <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange}/>
                        </>

    )
}

export default AllArticle